export const staticLabelsSearch = {
  en: {
    searchResultsFor: "Search Results for",
    searchResults: "Search Results",
  },
  id: {
    searchResultsFor: "Hasil Pencarian untuk",
    searchResults: "Hasil Pencarian",
  },
}
